require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./informatique-2-2-2-8.json") })
        }
      }, "path---informatique-2-2-2-8");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---informatique-2-2-2-8!./.cache/json/informatique-2-2-2-8.json
// module id = 465
// module chunks = 231608221292675